import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { getInvestigationTimelogQuery } from "./investigation-timelog.operations";
import { IApiInvestigationTimelogConnection, IApiInvestigationMetricsFilter } from 'src/app/shared/modules/graphql/types/types';
import { IGqlBaseOptions } from "../../../interfaces";
import { connectionQuery } from "../../../helpers.class";

@Injectable()
export class GqlInvestigationTimelogService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationTimelogConnection> {
    return this.apollo.query(connectionQuery(getInvestigationTimelogQuery, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
